import Vue from 'vue';
import cookie from '../../../cookie/cookie';
import eventBus from '../../../utils/fresh-table';
export default Vue.extend({
    name: 'fundTerminalOrder',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            usernameZh: '',
            ruleForm: {
                terminateReason: '',
            },
            rules: {
                terminateReason: [
                    {
                        required: true,
                        message: '请输入终止理由，不超过100字',
                        trigger: 'blur',
                        max: 100,
                    },
                ],
            },
        };
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        cancle: function () {
            this.$emit('cancle-dialog');
        },
        getParams: function () {
            var _a = this.data, capitalCode = _a.capitalCode, contractCode = _a.contractCode;
            return Object.assign(this.ruleForm, {
                capitalCode: capitalCode,
                contractCode: contractCode,
                operator: this.usernameZh,
            });
        },
        submitForm: function () {
            var _this = this;
            this.$refs['ruleForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var data = _this.getParams();
                _this.$request({
                    url: '/proxy/fund-api/capital/contract/terminal',
                    method: 'post',
                    data: data,
                }).then(function (res) {
                    if (!res || res.errorCode !== 0) {
                        return;
                    }
                    _this.$message({
                        type: 'success',
                        message: '订单终止成功!',
                    });
                    setTimeout(function () {
                        _this.cancle();
                        eventBus.$emit('freshTable');
                    }, 1000);
                });
            });
        },
    },
});
